export default __webpack_public_path__ + "static/media/newlaser.f58b6fac.png";